import { get, head } from "@/utils/lodash";

export function resolveProductCardVintage(product) {
  const erpCurrentVintage = get(product, "erpProduct.currentVintage");
  if (erpCurrentVintage != null && `${erpCurrentVintage}`.trim() !== "") {
    return `${erpCurrentVintage}`;
  }

  const currentVintage = get(product, "currentVintage");
  if (currentVintage != null && `${currentVintage}`.trim() !== "") {
    return `${currentVintage}`;
  }

  const incomingVintage =
    get(product, "erpProduct.itemToCome.vintage") ||
    get(product, "itemToCome.vintage");
  if (incomingVintage != null && `${incomingVintage}`.trim() !== "") {
    return `${incomingVintage}`;
  }

  const technicalSheetYear = get(product, "technicalSheet.releaseYear");
  if (technicalSheetYear != null && `${technicalSheetYear}`.trim() !== "") {
    return `${technicalSheetYear}`;
  }

  const technicalSpecYear = get(head(get(product, "technicalSpecs", [])), "releaseYear");
  if (technicalSpecYear != null && `${technicalSpecYear}`.trim() !== "") {
    return `${technicalSpecYear}`;
  }

  return "NM";
}
